import { mergeFilterInputs, UserFilterInput } from "../../../../../Utilities";
import { useUserRecipients } from "../Recipients";

const teacherFilter: UserFilterInput = {
	person: [
		{
			employee: [
				{
					// TODO filtering for term
					or: [
						{
							teacherCourseSectionEnrollments: [
								{
									courseSection: [
										{
											studentCourseSectionEnrollments: [
												{
													student: [
														{
															relationships: [
																{
																	guardian: [
																		{
																			person: [
																				{
																					user: [
																						{
																							isCurrentEQ: true,
																						},
																					],
																				},
																			],
																		},
																	],
																},
															],
														},
													],
												},
											],
										},
									],
								},
							],
						},
						{
							teacherHomeRoomSectionEnrollments: [
								{
									homeRoomSection: [
										{
											studentHomeRoomSectionEnrollments: [
												{
													student: [
														{
															relationships: [
																{
																	guardian: [
																		{
																			person: [
																				{
																					user: [
																						{
																							isCurrentEQ: true,
																						},
																					],
																				},
																			],
																		},
																	],
																},
															],
														},
													],
												},
											],
										},
									],
								},
							],
						},
					],
				},
			],
		},
	],
};

export function useTeacherRecipients(search?: string | null, userFilterInput?: UserFilterInput) {
	return useUserRecipients(
		userFilterInput ? mergeFilterInputs<UserFilterInput>({ search, ...userFilterInput }, teacherFilter) : teacherFilter,
	);
}
